// Copyright (c) 2016 Deere & Company

import ProductDetails from '../../product/details/state-connector';

export default {
    component: ProductDetails,
    name: 'PRODUCT_DETAILS',
    path: ':pin'
};



// WEBPACK FOOTER //
// ./src/routes/products/details-route.js